<template>

	<v-card>
		<v-card-title class="headline">Factura de compra</v-card-title>

		<v-card-text v-if="datos">

			<v-text-field
				v-model="datos.fechaDeEmisión"
				label="Fecha de emisión de la factura por parte del tercero"
				readonly
			></v-text-field>

			<br>
			<v-simple-table>
				<template v-slot:default>
					<thead>
						<tr>
							<th>Producto</th>
							<th class="text-right">Precio unitario</th>
							<th class="text-right">Cantidad</th>
							<th class="text-right">Precio total</th>
						</tr>
					</thead>
					<tbody v-if="datos.productos">
						<tr v-for="(p, i) in datos.productos" :key="`p${i}`">
							<td>
								{{ p.descripción }}
							</td>
							<td class="text-right">
								{{ moneda(p.precioUnitario) }}
							</td>
							<td class="text-right">
								{{ número(p.cantidad) }}
							</td>
							<td class="text-right">
								{{ moneda(p.precioTotal) }}
							</td>
						</tr>
					</tbody>
				</template>
			</v-simple-table>

			<v-spacer></v-spacer>

			<div class="d-flex mt-3">
				<v-spacer></v-spacer>
				<table class="totales">
					<tbody>
						<tr>
							<td style="text-align: right">TOTAL:</td>
							<td class="text-right">{{ moneda(datos.total) }}</td>
						</tr>
					</tbody>
				</table>
			</div>

		</v-card-text>

		<v-card-text>
			<v-alert type="error" class="text-center mt-8">
				¿Está seguro de que quiere anular esta factura de compra?
			</v-alert>
		</v-card-text>

		<v-card-actions>
			<v-spacer></v-spacer>

			<v-btn
				color="grey darken-1"
				text
				:disabled="fuente.anulando"
				@click="cancelar"
			>
				Cancelar
			</v-btn>

			<v-btn
				color="red darken-1"
				text
				:loading="fuente.anulando"
				@click="anular"
			>
				Sí, anular
			</v-btn>
		</v-card-actions>
	</v-card>

</template>

<script>
import { facturasDeCompra } from '@/../../cliente_comun/fuentes'
import { número, moneda } from '@/../../cliente_comun/utilidades'

export default {
	name: 'factura-compra-anular',
  data: () => ({
		fuente: facturasDeCompra
	}),
	props: ['datos'],
	methods: {
		número,
		moneda,
		anular: function() {
			let confirma = window.confirm('¿Está seguro de que quiere ANUlAR esta factura de compra?')
			if (confirma) {
				this.fuente.anular(this.datos.identificador).then(() => {
					this.$emit('anular', true)
				}).catch(() => { })
			}
		},
		cancelar: function() {
			this.$emit('cancelar', true)
		},
	}
}
</script>